import { render, staticRenderFns } from "./ModelGroupTable.vue?vue&type=template&id=648d0f29&scoped=true"
import script from "./ModelGroupTable.vue?vue&type=script&lang=js"
export * from "./ModelGroupTable.vue?vue&type=script&lang=js"
import style0 from "./ModelGroupTable.vue?vue&type=style&index=0&id=648d0f29&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648d0f29",
  null
  
)

export default component.exports